// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { env } from "process";

export const environment = {
  production: false,
  apiUrl: 'https://api.staging.bitssa.com',
  DEBUG: 'kit:*',
  BINANCE_PRIVATE_KEY: 'DEADBEEF',
  // PSI_FORM_URL: 'https://stagingcheckout.psigate.com/HTMLPost/HTMLMessenger',
  PSI_FORM_URL: 'https://checkout.psigate.com/HTMLPost/HTMLMessenger',
  PSI_STORE_KEY_DB: 'VVphwSUpVgkhfLGg2AU200017',
  // PSI_STORE_KEY_CC: 'VVphwSUpVgkhfLGg2AU200017',
  PSI_STORE_KEY_CC: 'EJ6BPhgz8rcat6vexZz020671',
  APP_URL: 'https://bitssa-ui.vercel.app/'
  // APP_URL: 'http://localhost:4200'
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
